import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthProvider } from './Component/AuthContext'
import { BrowserRouter } from 'react-router-dom'
import { InstituteProvider } from './Component/commonComponents/InstituteContext'
import { SubscriptionNeedPlanProvider } from './Component/commonComponents/SubscriptionNeedPlanContext'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { GOOGLE_CLIENT_ID } from './config/googleAuth'

const appTree = (
  <BrowserRouter>
    <AuthProvider>
      <InstituteProvider>
        <SubscriptionNeedPlanProvider>
          <App />
        </SubscriptionNeedPlanProvider>
      </InstituteProvider>
    </AuthProvider>
  </BrowserRouter>
)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
    GOOGLE_CLIENT_ID ? (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{appTree}</GoogleOAuthProvider>
    ) : (
      appTree
    )
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
